// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import projectsReducer from './projects/projectsSlice';
import rolesReducer from './admin/rolesSlice';
import sidebarReducer from './sidebarSlice';
import applicationTypesReducer from './applicationTypes/applicationTypesSlice';
import distributorsReducer from './distributors/distributorsSlice';
import expensesReducer from './expenses/expensesSlice';
import aitimeReducer from './aitime/aitimeSlice';
import gymvizReducer from './gymviz/gymvizSlice';
import apiTokensReducer from './apiTokens/apiTokensSlice';
import customersReducer from './customers/customersSlice';
import leadsReducer from './leads/leadsSlice';
import reportsReducer from './reports/reportsSlice';
import dashboardReducer from './dashboard/dashboardSlice';
import notificationsReducer from './notifications/notificationsSlice';
import issuesReducer from './issues/issuesSlice';
import budgetsReducer from './budgets/budgetsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    roles: rolesReducer,
    sidebar: sidebarReducer,
    applicationTypes: applicationTypesReducer,
    distributors: distributorsReducer,
    expenses: expensesReducer,
    aitime: aitimeReducer,
    gymviz: gymvizReducer,
    apiTokens: apiTokensReducer,
    customers: customersReducer,
    leads: leadsReducer,
    reports: reportsReducer,
    dashboard: dashboardReducer,
    notifications: notificationsReducer,
    issues: issuesReducer,
    budgets: budgetsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;